import React, { useState } from 'react'
import emailjs from 'emailjs-com';
import {
  OverlayWrapper,
  ContactContainer,
  Heading,
  HeadingTitle,
  InputsContainer,
  UntoggleButton,
  PersonInfoInputsContainer,
  NameInput,
  EmailInput,
  EmailMessageContainer,
  MessageInput,
  Footer,
  SendMessageButton
} from './styles/Overlay.styles'
import ErrorIcon from '@mui/icons-material/Error';
import CheckIcon from '@mui/icons-material/Check';

function Overlay({ isToggled, toggle }) {
  const [fade, setFade] = useState('in')
  const [messageError, setMessageError] = useState(false)
  const [messageSuccess, setMessageSuccess] = useState(false)
  const [messageInput, setMessageInput] = useState({
    fullName: '',
    email: '',
    message: ''
  });

  const [validInput, setValidInputs] = useState({
    fullName: false,
    email: false,
    message: false
  })

  const handleMessageChange = (e) => {
    const { name, value } = e.target;
    setMessageInput(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSendMessage = () => {
    const isInputsNotValid = messageInput.email === '' ||
      messageInput.fullName === '' ||
      messageInput.message === ''

    Object.keys(messageInput).forEach(key => {
      setValidInputs(prev => ({
        ...prev,
        [key]: messageInput[key] === '' || messageInput[key] === null ? true : false
      }))})

    if (isInputsNotValid) {
      return
    }

    const templateParams = {
      name: messageInput.fullName,
      email: messageInput.email,
      message: messageInput.message,
    };

    emailjs.send(
      'service_qemc6bl',
      'template_9z79xxr',
      templateParams,
      'cLQL-J1a9YVjzReI2'
    ).then((success) => {
      setMessageSuccess(true)
      setTimeout(() => {
        setMessageSuccess(false)
      }, 2000)

      setFade('out')
      setTimeout(() => {
        toggle()
      }, 1500)
    }).catch((err) => {
      setMessageError(true)
      setTimeout(() => {
        setMessageError(false)
      }, 2000)
    })
  }

  const handleClose = () => {
    setFade('out')
    setTimeout(() => {
      toggle()
    }, 300)
  }

  return (
    <OverlayWrapper $visible={isToggled} $fade={fade} >
      <ContactContainer $visible={isToggled} $fade={fade} >
        <Heading>
          <HeadingTitle>Contact me</HeadingTitle>
          <UntoggleButton onClick={handleClose} aria-label="Close popup">✕</UntoggleButton>
        </Heading>
        <InputsContainer>
          <PersonInfoInputsContainer>
            <NameInput
              $error={validInput.fullName}
              name='fullName'
              onChange={handleMessageChange}
              value={messageInput.fullName}
              placeholder='Full name' />
            <EmailInput
              $error={validInput.email}
              name='email'
              onChange={handleMessageChange}
              value={messageInput.email}
              placeholder='Email' />
          </PersonInfoInputsContainer>
          <EmailMessageContainer>
            <MessageInput
              $error={validInput.message}
              name='message'
              onChange={handleMessageChange}
              value={messageInput.message}
              placeholder='Type your message...' />
          </EmailMessageContainer>
        </InputsContainer>
        <Footer>
          <SendMessageButton $error={messageError} $success={messageSuccess} onClick={handleSendMessage}>
            { messageSuccess ? <CheckIcon /> : messageError ? <ErrorIcon /> : 'Send' }
          </SendMessageButton>
        </Footer>
      </ContactContainer>
    </OverlayWrapper>
  )
}

export default Overlay